import { useEffect } from "react";

import { IsNullOrEmpty } from "shared/helpers/NullEmptyHelpers";

export function useServerGridAggregates(
  fieldTotalsData,
  aggregateColumnSettings,
  sendAggregatesParentCallback
) {
  // if any parameters are missing, return
  // if (
  //   !mainGridData ||
  //   !mainGridDataState ||
  //   !aggregateColumnSettings ||
  //   !sendAggregatesParentCallback
  // ) {
  //   return;
  // }

  // if (dataIsLoading) {
  //   return;
  // }

  // if (IsNullOrEmpty(mainGridData)) {
  //   return;
  // }

  // if (IsNullOrEmpty(mainGridDataState)) {
  //   return;
  // }

  // if (IsNullOrEmpty(fieldTotalsValue.value)) {
  //   return;
  // }

  // console.log("from useServerGridAggregates", mainGridData);
  // console.log("from useServerGridAggregates", mainGridDataState);

  // const fieldTotals = useMemo(() => {
  //   return fieldTotalsData;
  // }, [fieldTotalsData]);

  // console.log(
  //   "from useServerGridAggregates fieldTotalsValue",
  //   fieldTotalsValue
  // );

  // if (IsNullOrEmpty(mainGridDataState)) {
  //   return;
  // }

  // const fieldTotalsData = useMemo(() => {
  //   if (dataIsLoading) {
  //     return "";
  //   }

  //   return GetObjectPropertyValue(mainGridData, "fieldTotals", "");
  // }, [[mainGridData]]);

  //console.log("from useServerGridAggregates", mainGridData);
  // function setAggregates(currentDataState) {
  //   let aggregates = aggregateBy(
  //     currentDataState.data,
  //     aggregateColumnSettings
  //   );

  //   let returnValues = {};
  //   returnValues.data = aggregates;
  //   returnValues.filter = currentDataState.filter;

  //   sendAggregatesParentCallback(returnValues);
  // }

  // let fieldTotalsValue = GetObjectPropertyValue(
  //   mainGridData,
  //   "fieldTotals",
  //   ""
  // );

  function generateAggregatesObject(fieldname, value) {
    return {
      [fieldname]: {
        sum: value,
      },
    };
  }

  function setAggregates(aggregatesData) {
    //alert pushing the aggregatesData to the aggregateColumnSettings
    //push each property from aggregatesData to the aggregateColumnSettings
    let aggregateColumnSettings = [];

    // I ned the following structure:
    let structure = {
      promiseToPay: { sum: 300072.1100000001 },
      paidAmount: { sum: 1489.2099999999991 },
    };
    // I need to convert it to the following structure:  {"promiseToPay":{"sum":300072.1100000001},"paidAmount":{"sum":1489.2099999999991}}
    let convertedStructure = [
      { field: "promiseToPay", aggregate: "sum", value: 300072.1100000001 },
      { field: "paidAmount", aggregate: "sum", value: 1489.2099999999991 },
    ];

    //can I generate this structure from the following structure:  {"fieldname":{"sum":value}

    let x = { property: "aggregate", value: 300072.1100000001 };

    //implement the conversion to new structure
    // for (let property in aggregatesData) {
    //   aggregateColumnSettings.push(
    //     generateAggregatesObject(property, aggregatesData[property])
    //   );
    // }

    let aggregateResult = {};

    //implement the conversion to new structure
    for (let property in aggregatesData) {
      let thisResult = generateAggregatesObject(
        property,
        aggregatesData[property]
      );

      //append thisResult to the right of aggregateResult
      aggregateResult = { ...aggregateResult, ...thisResult };
    }

    //alert(JSON.stringify(aggregateResult));

    // converty the json structure to an object
    let aggregateResult2 = JSON.parse(JSON.stringify(aggregateResult));

    aggregateColumnSettings.push(aggregateResult2);

    // for (let property in aggregatesData) {
    //   aggregateColumnSettings.push({
    //     field: property,
    //     aggregate: "sum",
    //     value: aggregatesData[property],
    //   });
    // }

    sendAggregatesParentCallback(aggregateColumnSettings);
    //sendAggregatesParentCallback(aggregateResult);
  }

  useEffect(() => {
    // if either  aggregateColumnSettings,sendAggregatesParentCallback is null then do not proceed
    if (
      IsNullOrEmpty(aggregateColumnSettings) ||
      IsNullOrEmpty(sendAggregatesParentCallback)
    ) {
      return;
    }

    // if no fieldTotalsData then do not proceed
    if (IsNullOrEmpty(fieldTotalsData)) {
      return;
    }

    setAggregates(fieldTotalsData);
  }, [fieldTotalsData]);
}
